<template>
  <pre class="content-pre">{{ decodeHtml(content) }}</pre>
</template>
<script>
import { decodeHtml } from '@g/utils'
export default {
  name: 'ContentPre',
  props: {
    content: String,
  },
  data () {
    return {
      decodeHtml,
    }
  },
}
</script>
